import styled from 'styled-components'

export const FileInput = styled.input`
  height: 0;
  opacity: 0;
  width: 0;

  &::-webkit-file-upload-button {
    width: 0;
    height: 0;
    padding: 0;
    border: 0;
    opacity: 0;
  }
`
